export default KR => {
  return {
    onClick: KR._addCallback('smartForm.onClick')
  }
}
